<template>
  <AcisoForm
    :ref="modal_id"
    :modal="false"
    :panel_id="modal_id"
    :panel_title="modal_title"
    :read_only="true"
    :size="size"
    @cancel="cancelled"
  >
    <b-row>
      <b-col cols="8">
        <h2 v-if="current_obj_">{{ current_obj_.title }}</h2>
      </b-col>
      <b-col
        v-if="isDocumentation"
        cols="4"
      >
        <b-button
          class="mr-1 mb-1 pull-right"
          :style="{ width: '170px' }"
          variant="outline-primary"
          @click="loadDocumentation()"
        >
          <i class="fa far fa-external-link" />&nbsp; {{ _('Documentation') }}
        </b-button>
        <b-button
          v-if="history && history.length > 1 && showPreviousButton"
          v-b-tooltip
          class="mr-1 mb-1 pull-right"
          :title="_('Go to previous page')"
          variant="outline-primary"
          @click="previousPage()"
        >
          <i class="far fa-hand-point-left" />
        </b-button>
      </b-col>
    </b-row>
    <div v-if="!hasChild">
      <b-col cols="12">
        <NdsMarkdownViewer
          v-if="current_obj_ && current_obj_.content"
          :sanitize="false"
          :value="content_with_video"
        />
        <b-card
          v-else
          class="mt-3"
        >
          <span class="text-muted">
            {{ doc_msg }}
          </span>
        </b-card>
      </b-col>
    </div>
    <div v-else>
      <b-col
        v-if="current_obj_ && current_obj_.content"
        cols="12"
      >
        <NdsMarkdownViewer
          :sanitize="false"
          :value="content_with_video"
        />
        <hr v-if="current_obj_.children.length > 0" />
        <ul v-if="current_obj_.children.length > 0">
          <li
            v-for="c in current_obj_.children"
            :key="c.identifier"
          >
            <a
              href="#"
              @click="navigatePage(c)"
            >
              {{ c.title }}
            </a>
          </li>
        </ul>
        <div
          v-if="!$store.getters.isSupport"
          class="mt-2"
        >
          <div v-if="current_obj_ && current_obj_.content">
            <b-card
              v-show="!has_voted"
              class="mt-4"
            >
              <Feedback
                :current_rating="current_obj_.current_rating"
                @sendVote="sendVote"
              />
            </b-card>
            <b-card
              v-show="has_voted"
              class="mt-4"
            >
              <h5 class="panel-title mb-2">
                <translate>Thank you for your feedback!</translate>
              </h5>
            </b-card>
          </div>
        </div>
      </b-col>
      <b-col
        v-else
        cols="12"
      >
        <b-card class="mt-3">
          <span class="text-muted">
            <translate>This page has no information yet.</translate>
          </span>
        </b-card>
      </b-col>
    </div>
  </AcisoForm>
</template>

<script>
import AcisoForm from '@/components/layout/AcisoForm.vue'
import EditMixin from '@/mixins/EditMixin'
import Feedback from '@/contexts/documentation/feedback/Feedback.vue'
import { sendWikiVoteMixin } from '@/contexts/documentation/wiki/WikiMixin.services'
import NdsMarkdownViewer from '@/components/NewDesignSystem/NdsMarkdown/NdsMarkdownViewer.vue'

export default {
  name: 'Wiki',
  components: {
    NdsMarkdownViewer,
    AcisoForm,
    Feedback,
  },
  mixins: [EditMixin],
  props: {
    history: Array,
    hasChild: {
      type: Boolean,
      default: false,
    },
    isDocumentation: {
      type: Boolean,
      default: true,
    },
    size: {
      type: String,
      default: 'lg',
    },
  },
  data: function () {
    return {
      modal_title: 'Contextual Help',
      current_page: null,
      hide_footer_on: [0],
      current_node_page: null,
      api_endpoint: 'wiki',
      doc_msg: this._(
        'This page has no contextual documentation yet, but you can browse the documentation using the button above.'
      ),
      has_voted: false,
    }
  },
  computed: {
    showPreviousButton: function () {
      if (this.history) {
        return !(
          this.history[this.history.length - 2] === 'no-page' && this.history[this.history.length - 1] === 'no-page'
        )
      }
      return false
    },
    content_with_video: function () {
      if (this.current_obj_ && this.current_obj_.content) {
        let content = this.current_obj_.content
        if (!this.current_obj_.link_id || !this.current_obj_.provider) {
          return content
        } else {
          const shortcode = '!video!'
          const video_id = this.current_obj_.link_id
          if (this.current_obj_.provider === 'VIMEO') {
            const video_vimeo =
              '<br><iframe src="https://player.vimeo.com/video/' +
              video_id +
              '" width="640" height="360" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" webkitallowfullscreen="" mozallowfullscreen="" allowfullscreen=""></iframe><br>'
            if (content.includes(shortcode)) {
              content = content.replace(shortcode, video_vimeo)
            } else {
              content = video_vimeo + this.current_obj_.content
            }
          } else if (this.current_obj_.provider === 'YOUTUBE') {
            const video_youtube =
              '<br><iframe src="https://www.youtube.com/embed/' +
              video_id +
              '" width="640" height="360" title="YouTube video player" frameborder="0" allow="autoplay; picture-in-picture" allowfullscreen></iframe><br>'
            if (content.includes(shortcode)) {
              content = content.replace(shortcode, video_youtube)
            } else {
              content = video_youtube + this.current_obj_.content
            }
          }
          return content
        }
      } else {
        return null
      }
    },
    modal_view_title: function () {
      if (this.isDocumentation) {
        return this._('Contextual help')
      } else {
        return this._('Tenacy')
      }
    },
  },
  watch: {},
  methods: {
    preFormHandler() {
      this.has_voted = false
    },
    previousPage() {
      this.$emit('previousPage')
    },
    loadDocumentation() {
      const routeData = this.$router.resolve({ name: 'documentation' })
      window.open(routeData.href, '_blank')
    },
    navigatePage(node) {
      this.$emit('childNav', node)
    },
    async sendVote(rating) {
      if (!this.current_obj_.identifier) {
        return
      }

      try {
        await sendWikiVoteMixin(this.current_obj_.identifier, rating)
        this.has_voted = true
      } catch (e) {
        this.$toast.alert(e)
      }
    },
  },
}
</script>
